export type NotificationChannelSelection = 'email' | 'sms' | 'whatsapp' | 'both' | 'all';

export function channelUsesEmail(channel: NotificationChannelSelection): boolean {
  return channel === 'email' || channel === 'both' || channel === 'all';
}

export function channelUsesSms(channel: NotificationChannelSelection): boolean {
  return channel === 'sms' || channel === 'both' || channel === 'all';
}

export function channelUsesWhatsApp(channel: NotificationChannelSelection): boolean {
  return channel === 'whatsapp' || channel === 'all';
}

export const NOTIFICATION_CHANNEL_OPTIONS: Array<{ value: NotificationChannelSelection; label: string }> = [
  { value: 'email', label: 'Email' },
  { value: 'sms', label: 'SMS' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'both', label: 'Email & SMS' },
  { value: 'all', label: 'Email, SMS & WhatsApp' },
];
